// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1NtoO","list":"styles_list__3gY3x"};